import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import emailReducer from '../features/shared/emailSlice';
import appReducer from '../features/shared/appSlice';
import whatsonReducer from '../features/whatson/whatsonSlice';
import faqReducer from '../features/faq/faqSlice';
import fileReducer from '../features/shared/fileSlice';
import ticketReducer from '../features/tickets/ticketSlice'
import { setupListeners } from '@reduxjs/toolkit/query';

export const store = configureStore({
  reducer: {
    emailstate: emailReducer,
    whatsonstate: whatsonReducer,
    faqstate: faqReducer,
    appstate: appReducer,
    filestate: fileReducer,
    ticketstate: ticketReducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      // specState.specs has a lot of class instances, but there are very simple, containing
      // string, number, boolean and Array
      serializableCheck: {ignoredPaths: [
        
      ],
    }
    }),
    
});
// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;